import { Button, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { SimplePageWrapper } from '~/@ui/simple-page-wrapper/SimplePageWrapper'
import { Header } from '~/@ui/header/Header'
import DucatsSvg from '~/@ui/_sharedSvgs/dynamicSvgs/Ducats.svg?react'
import HouseSvg from '~/@ui/_sharedSvgs/dynamicSvgs/House.svg?react'

export const AccountSelectorPage = () => {
  const navigate = useNavigate()

  const [accountType, setAccountType] = useState('')

  const isInvestor = accountType === 'investor'
  const isOwner = accountType === 'owner'

  const continueToRegister = () => {
    if (isInvestor) {
      navigate('/account/register/investor')
    }

    if (isOwner) {
      navigate('/vlastnik/intro')
    }
  }

  return (
    <SimplePageWrapper
      onClickBack={() => (window.location.href = 'https://bonaship.sk')}>
      <Stack className="h-full justify-between">
        <Stack className="px-5">
          <Header
            title="Registrovať sa ako..."
            text="Zvoľte, či chcete investovať do Druhého dôchodku alebo ho čerpať."
            className="pt-6"
          />

          <Stack className="gap-6 mt-8">
            <Stack className="flex-row gap-3">
              <Stack
                className={`w-full h-[120px] justify-center items-center gap-2 ${isInvestor ? 'bg-zBlack200' : 'bg-zGrey200'} rounded-4d`}
                onClick={() => setAccountType('investor')}>
                <DucatsSvg
                  className={isInvestor ? 'fill-zWhite200' : 'fill-zBlack200'}
                />
                <Typography
                  className={`text-3d font-medium ${isInvestor ? 'text-zWhite200' : 'text-zBlack200'}`}>
                  Investor
                </Typography>
              </Stack>

              <Stack
                className={`w-full h-[120px] justify-center items-center gap-2 ${isOwner ? 'bg-zBlack200' : 'bg-zGrey200'} rounded-4d`}
                onClick={() => setAccountType('owner')}>
                <HouseSvg
                  className={isOwner ? 'fill-zWhite200' : 'fill-zBlack200'}
                />
                <Typography
                  className={`text-3d font-medium ${isOwner ? 'text-zWhite200' : 'text-zBlack200'}`}>
                  Senior
                </Typography>
              </Stack>
            </Stack>

            <Button
              variant="contained"
              className="w-full h-14 self-center"
              disabled={!accountType}
              onClick={continueToRegister}>
              Pokračovať
            </Button>
          </Stack>
        </Stack>

        <Stack className="items-center pb-14">
          <Typography className="text-sm font-medium text-zGrey400">
            Máte u nás účet?
          </Typography>
          <Link to="/account">
            <Typography className="text-sm font-semibold text-zBlack200">
              Prihlásiť sa
            </Typography>
          </Link>
        </Stack>
      </Stack>
    </SimplePageWrapper>
  )
}
